import { render, staticRenderFns } from "./formGroupView.vue?vue&type=template&id=51922f22&scoped=true&"
import script from "./formGroupView.vue?vue&type=script&lang=js&"
export * from "./formGroupView.vue?vue&type=script&lang=js&"
import style0 from "./formGroupView.vue?vue&type=style&index=0&id=51922f22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51922f22",
  null
  
)

export default component.exports